import React from 'react'
import Layout from './Layout'
import './style/reset.scss'
import './style/antd-reset.scss'
import './style/common.scss'

const App: React.FC = () => {
  return <Layout />
}

export default App
